import { render, staticRenderFns } from "./file-document-edit-outline.vue?vue&type=template&id=0bb14cae&"
import script from "./file-document-edit-outline.vue?vue&type=script&lang=js&"
export * from "./file-document-edit-outline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports